import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/tailwind.utils'
import type { ArticleItem } from '../types'

const ArticleAccordionRow = ({ article }: { article: ArticleItem }) => {
  const { title, description, href } = article

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={`${title} (opens in a new tab)`}
      className="group flex items-start justify-between gap-4 py-3 px-2 hover:bg-neutral transition-colors"
    >
      <div className="flex flex-col gap-0.5">
        <p className="text-sm font-medium text-foreground group-hover:text-foreground">{title}</p>
        <p className="text-xs text-muted-foreground dark:text-card-foreground">{description}</p>
      </div>

      <span
        className={cn(
          buttonVariants({ variant: 'ghost', size: 'sm' }),
          'shrink-0 pointer-events-none',
        )}
      >
        Read →
      </span>
    </a>
  )
}

export default ArticleAccordionRow
